import { gql } from '@apollo/client'

export const PRODUCT_DASHBOARD_INTERVAL_STAT_FRAGMENT = gql`
  fragment ProductDashboardIntervalStat on ProductDashboardIntervalStat {
    id
    date
    category
    description
    totalRevenue
    totalEarnings
    volume
    vpo
    previousVolume
    facings
    emptyFacings
    sovi
    revenuePerFacing
    earningsPerFacing
  }
`
